"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Motion = void 0;

var _reactNative = require("react-native");

var _createMotionComponent = require("./createMotionComponent");

var _MotionPressable = require("./MotionPressable");

let Motion;
exports.Motion = Motion;

(function (_Motion) {
  const View = _Motion.View = (0, _createMotionComponent.createMotionComponent)(_reactNative.Animated.View);
  const Text = _Motion.Text = (0, _createMotionComponent.createMotionComponent)(_reactNative.Animated.Text);
  const FlatList = _Motion.FlatList = (0, _createMotionComponent.createMotionComponent)(_reactNative.Animated.FlatList);
  const Image = _Motion.Image = (0, _createMotionComponent.createMotionComponent)(_reactNative.Animated.Image);
  const ScrollView = _Motion.ScrollView = (0, _createMotionComponent.createMotionComponent)(_reactNative.Animated.ScrollView);
  const SectionList = _Motion.SectionList = (0, _createMotionComponent.createMotionComponent)(_reactNative.Animated.SectionList);
  const Pressable = _Motion.Pressable = _MotionPressable.MotionPressable;
})(Motion || (exports.Motion = Motion = {}));
//# sourceMappingURL=AnimatedComponents.js.map